

export default class Base {
  constructor(obj) {
    this._doc = obj;
  }

  get(attr) {
    return this._doc[attr];
  }

  set(attr, value) {
    if (typeof attr === 'object') {
      let obj = attr;
      for (let attr in obj) {
        this.set(attr, obj[attr]);
      }
    } else {
      this._doc[attr] = value;
    }
  }

  toJSON() {
    return toJSON(this);
  }
}

// 深层不做处理
function toJSON(model) {
  let result = {};
  for (let attr in model._doc) {
    let value = model._doc[attr];

    if (value instanceof Base) {
      result[attr] = toJSON(value);
    } else if (typeof value !== 'undefined') {
      result[attr] = value;
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/models/Base.js